import request from '../utils/request';

// 查询帮助中心分类列表
export const listCategories = (params) => {
  return request({
    url: '/help-center/category/list',
    method: 'get',
    params
  });
};

// 创建帮助中心分类
export const createCategory = (data) => {
  return request({
    url: '/help-center/category/create',
    method: 'post',
    data
  });
};

// 更新帮助中心分类
export const updateCategory = (id, data) => {
  return request({
    url: `/help-center/category/update/${id}`,
    method: 'put',
    data
  });
};

// 更新帮助中心分类状态
export const updateCategoryStatus = (id, status) => {
  return request({
    url: `/help-center/category/status/${id}`,
    method: 'put',
    params: { status }
  });
};

